module.exports = __webpack_public_path__ + "files/ee4ced24265cb7a5e3c22752fd9478d0.png";